<script>
  import { fade } from 'svelte/transition';
  import { isAllTooManyPeople } from '../store/fetchAvailabilityEnableDates';
  import ItemAvailabilityStatus from './ItemAvailabilityStatus.svelte';
  import ItemBookButton from './ItemBookButton.svelte';
  import ItemBookingStatus from './ItemBookingStatus.svelte';
  import ItemCosts from './ItemCosts.svelte';
  import ItemDescription from './ItemDescription.svelte';

  export let UnitTypeName;
  export let Status;
  export let Description;
  export let BookingUrl;
  export let Charges;
  export let Total;
  export let TotalNights;
  export let BusinessCode;
  export let ProviderId;
  export let BookingMessage;

  $: isAvailable = Status === 'A';
</script>

<div class="Box-row pb-5" transition:fade>
  <div class="d-table width-full">
    <div
      class="col-sm-8 d-sm-table-cell v-align-top"
      data-testid="availability-listing-item">
      <div class="d-sm-flex">
        <h2 class="h3 mb-1 mb-sm-0 mr-sm-3 mt-0 my-0 text-teal">
          {UnitTypeName}
        </h2>
        <ItemAvailabilityStatus {Status} />
      </div>

      {#if Description}
        <ItemDescription {Description} />
      {/if}

      {#if isAvailable && Array.isArray(Charges) && !$isAllTooManyPeople}
        <ItemCosts {Charges} {Total} {TotalNights} />
      {:else if !isAvailable}
        <ItemBookingStatus {Status} {BookingMessage} />
      {/if}

      {#if !$isAllTooManyPeople}
        <ItemBookButton {Status} {BookingUrl} {ProviderId} {BusinessCode} />
      {/if}
    </div>
  </div>
</div>
